const UPDATE_TRANSLATIONS = 'dofe-bo/UPDATE_TRANSLATIONS'
const UPDATE_TRANSLATIONS_SUCCESS = 'dofe-bo/UPDATE_TRANSLATIONS_SUCCESS'
const UPDATE_TRANSLATIONS_FAIL = 'dofe-bo/UPDATE_TRANSLATIONS_FAIL'

const UPLOAD_TRANSLATION = 'dofe-bo/UPLOAD_TRANSLATION'
const UPLOAD_TRANSLATION_SUCCESS = 'dofe-bo/UPLOAD_TRANSLATION_SUCCESS'
const UPLOAD_TRANSLATION_FAIL = 'dofe-bo/UPLOAD_TRANSLATION_FAIL'

const SET_UPLOAD_TRANSLATION_RESULT = 'dofe-bo/bulk/SET_UPLOAD_TRANSLATION_RESULT'
const SET_UPDATE_ALL_TRANSLATION_RESULT = 'dofe-bo/bulk/SET_UPDATE_ALL_TRANSLATION_RESULT'

const initialState = {
    isLoading: false,
    uploadTranslation: {
      isLoading: false,
      loaded: false,
      result: {
        status: null,
        resultMap: {}
      }
    }
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_TRANSLATIONS:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_TRANSLATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.result
            }
        case UPDATE_TRANSLATIONS_FAIL:
            return {
                ...state,
                isLoading: false
            }
        case SET_UPDATE_ALL_TRANSLATION_RESULT:
            return {
                ...state,
                updateTranslations: {
                    result: action.data
                }
            }
      case UPLOAD_TRANSLATION:
        return {
          ...state,
          uploadTranslation: {
            ...state.uploadTranslation,
            isLoading: true,
            loaded: false
          }
        }
      case UPLOAD_TRANSLATION_SUCCESS:
        return {
          ...state,
          uploadTranslation: {
            ...state.uploadTranslation,
            isLoading: false,
            loaded: true,
            result: action.result
          }
        }
      case UPLOAD_TRANSLATION_FAIL:
        return {
          ...state,
          uploadTranslation: {
            ...state.uploadTranslation,
            isLoading: false,
            error: action.error
          }
        }
      case SET_UPLOAD_TRANSLATION_RESULT:
        return {
          ...state,
          uploadTranslation: {
            result: action.data
          }
        }
        default:
            return state
    }
}

export const updateTranslations = (projectCodes, locale) => ({
    types: [
        UPDATE_TRANSLATIONS,
        UPDATE_TRANSLATIONS_SUCCESS,
        UPDATE_TRANSLATIONS_FAIL
    ],
    promise: client =>
        client.post(`api/app-init/poe-translations/${projectCodes}/${locale}`)
})

export const uploadTranslation = data => {
  return {
    types: [
      UPLOAD_TRANSLATION,
      UPLOAD_TRANSLATION_SUCCESS,
      UPLOAD_TRANSLATION_FAIL
    ],
    promise: client =>
      client.post('apiv2/system/translation/upload', { data })
  }
}

export function setUploadTranslationResult(data) {
  return {
    type: SET_UPLOAD_TRANSLATION_RESULT,
    data
  }
}


export function setUpdateAllTranslationsResult(data) {
    return {
        type: SET_UPDATE_ALL_TRANSLATION_RESULT,
        data
    }
}
